import { ProtectedRoute } from "@app/protected-route";
import StressTestResults from "@pages/stress-test/stress-test-results";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/stress-test/results")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<ProtectedRoute requiredPermissions={["perform_ifrs"]}>
			<StressTestResults />
		</ProtectedRoute>
	);
}
